import React from 'react'
import { useHistory } from 'react-router-dom'

import { ErrorLayout } from './error-layout'

export const NotFoundPage = () => {
  const history = useHistory()
  const handleOnClickHome = () => {
    history.push('/')
  }

  return (
    <ErrorLayout
      code="404"
      label={{ text: 'Page Not Found', tx: 'error.404.left.found.page' }}
      message={{
        text: 'The page you are looking for doesn’t exist, you can return to the home.',
        tx: 'error.404.second.title.text'
      }}
      onHome={handleOnClickHome}
    />
  )
}
